/**
 * 解析會員文件路徑，取得「文件類型 + 文件 ID」組合字串。
 *
 * 路徑格式範例：(後端給的，由於資料庫沒有存檔名故用此方式)
 * /members/{memberId}/doc/membership-suspend/{contractID}/plugin.jpg
 *
 * Example:
 * "/members/24375/doc/membership-suspend/272/plugin.jpg"
 * → "membership-suspend_272"
 *
 * @param {string} path - 會員文件完整路徑
 * @returns {string} 回傳格式為 "membership_suspend_{memberID}_{contractID}" 的字串
 */
const getMembershipSuspendFilePathName = path => {
	if (!path) return "";
	const segments = path.split("/").filter(Boolean);
	if (path.length === 0) return "";
	const memberID = segments[1];
	const contractID = segments[4];
	return `membership_suspend_${memberID}_${contractID}`;
};

export { getMembershipSuspendFilePathName };
